var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstragramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H4C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0Z",
    fill: "#393184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9675 7.55995C11.0601 8.18413 10.9535 8.82161 10.6629 9.38171C10.3722 9.94181 9.91241 10.396 9.34877 10.6797C8.78513 10.9634 8.14639 11.0621 7.52339 10.9619C6.9004 10.8616 6.32487 10.5675 5.87868 10.1213C5.43249 9.67513 5.13835 9.0996 5.0381 8.47661C4.93786 7.85361 5.0366 7.21487 5.3203 6.65123C5.60399 6.08759 6.05819 5.62776 6.61829 5.33713C7.17839 5.04651 7.81587 4.93989 8.44005 5.03245C9.07674 5.12687 9.66619 5.42355 10.1213 5.87868C10.5765 6.33381 10.8731 6.92326 10.9675 7.55995Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstragramIcon);
export default __webpack_public_path__ + "static/media/instragram-icon.84cfc73c2fd5337184fc6328b8cc6313.svg";
export { ForwardRef as ReactComponent };